import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  DialogContent,
  Typography,
  Slider,
  Grid,
  TextField,
  Autocomplete,
} from '@mui/material';
import { Dialog } from '../../components/Dialog';
import { actions, selectors } from '../../store/dux/product-placement-vpi-dux';
import { useAlerts } from '../../hooks/use-alerts';

const relativeMaturityLimits = {
  min: 0,
  max: 6,
  step: 0.1,
};

export function VPIModal(props) {
  const { close, aaids, growerId } = props;
  const dispatch = useDispatch();
  const [rmRange, setRmRange] = useState([
    relativeMaturityLimits.min,
    relativeMaturityLimits.max,
  ]);
  const [selectedBrand, setSelectedBrand] = useState();
  const brands = useSelector(selectors.brands);
  const loadingBrands = useSelector(selectors.loadingBrands);
  const saveComplete = useSelector(selectors.saveComplete);
  const hasFailed = useSelector(selectors.hasFailed);
  const { showError } = useAlerts();

  useEffect(() => {
    dispatch(actions.loadBrands());
  }, [dispatch]);

  useEffect(() => {
    showError(hasFailed);
  }, [hasFailed, showError]);

  useEffect(() => {
    if (saveComplete) {
      close();
    }
  }, [saveComplete, close]);

  async function createVPIRecommendation() {
    await dispatch(
      actions.createVPIRecommendation(growerId, aaids, rmRange, selectedBrand),
    );
  }

  return (
    <Dialog
      title="Create Recommendation"
      onCancel={close}
      onSave={createVPIRecommendation}
      canSave={aaids.length > 0 && !!selectedBrand}
      keepMounted
      open
      sx={{ top: 96 }}
    >
      <DialogContent>
        <Grid
          container
          spacing={3}
          alignItems="center"
          sx={{ maxWidth: '60%' }}
        >
          <Grid item xs={12}>
            <Box sx={{ marginBottom: 5 }}>
              <Typography variant="subtitle1">Relative Maturity</Typography>
              <Typography variant="body2">
                Use the slider to select RM values to filter by.
              </Typography>
            </Box>

            <Slider
              getAriaLabel={() => 'Relative Maturity'}
              onChange={(e) => setRmRange(e.target.value)}
              valueLabelDisplay="on"
              value={rmRange}
              step={relativeMaturityLimits.step}
              min={relativeMaturityLimits.min}
              max={relativeMaturityLimits.max}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle1">Select Brand</Typography>
            <Autocomplete
              id="brand-selector"
              loading={loadingBrands}
              options={brands}
              getOptionLabel={(option) => option.name}
              onChange={(_, value) => setSelectedBrand(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  data-testid="selectBrand"
                  helperText={!selectedBrand && 'Required'}
                  error={!selectedBrand}
                  required
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
